import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { NomineeOptOutPopupComponent } from '../nominee-opt-out-popup/nominee-opt-out-popup.component';
import { ConfigurationService } from '../../providers/configuration/configuration.service';
import { Utils } from 'src/app/_helpers';

@Component({
  selector: 'app-nomination-popup',
  templateUrl: './nomination-popup.component.html',
  styleUrls: ['./nomination-popup.component.scss']
})

export class NominationPopupComponent implements OnInit {
  nomineeUrl: string = '';


  constructor(
    public dialogRef: MatDialogRef<NominationPopupComponent>,
    private _dialog: MatDialog,
    private configurationService: ConfigurationService
  ) {
    this.nomineeUrl = this.configurationService.remoteConfigCacheObj['NomineeConfig']?.nomineeUrl;
  }

  closeDialog() {
    this.dialogRef.close();
    Utils.storageHelper.nominationPopupAccepted = true;
  }
  ngOnInit(): void {
  }

  openNomineeForm() {
    window.open(this.nomineeUrl, '_blank');
    this.closeDialog();
  }

  openOptOutPopup() {
    const optOutDialogRef = this._dialog.open(NomineeOptOutPopupComponent, {
      minHeight: 350,
      width: '800px',
      panelClass: 'expanding-dialog',
      backdropClass: 'risk-background',
      disableClose: true
    });
    // Close nomination popup and pass the opt-out dialog reference
    // so the parent can wait for it to close
    this.dialogRef.close({ optOutDialogRef });
  }
}
